const nav = {
	navList:[
		{name:'首页',id:'1', path:'/index'},
		{name:'服务申请',id:'2',  path:'/EPD',
			children:[
				{name:'EPD/CFP',id:'1', path:'/EPD'},
				{name:'PCR',id:'2', path:'/PCR'},
				{name:'LCA',id:'3', path:'/LCA'},
				{name:'GPI',id:'4', path:'/GPI'},
				{name:'我的申请',id:'5', path:'/portal?type=1'},
			],
		},		
		{name:'资讯',id:'5', path:'/news'},
		{name:'资源',id:'6', path:'/resource'},
		{name:'服务介绍',id:'7', path:'/service'},
		{name:'联系我们',id:'8',  path:'/connect',
			children:[
				{name:'联系我们',id:'9', path:'/connect'},
				{name:'关于我们',id:'10', path:'/about'},
				{name:'意见反馈',id:'11', path:'/feedback'}
			],
		},
	],
	usernav:[
		{name:'企业认证',id:'1', path:'/company'},
		{name:'个人中心',id:'2', path:'/user'},
		{name:'退出登录',id:'3', path:''},
	],
}

export default nav